// src/pages/game-fortune/HomeView.jsx

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fortuneCardApi } from './services/fortuneCardApi';
import slip from '../../assets/images/game-fortune/slip.png';
import TermsPrivacy from './TermsPrivacy'

import './Home.css';

const HomeView = ({ onStart }) => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [myGroup, setMyGroup] = useState(null);
  const [hasCard, setHasCard] = useState(false);
  const [showTerms, setShowTerms] = useState(false);


  useEffect(() => {
    const initializeApp = async () => {
      await initialize();
      await checkUserStatus();
    };

    initializeApp();
  }, []);

  // ✅ Initialize player
  const initialize = async () => {
    try {
      setLoading(true);
      //setError(null);
      console.log('🔄 Initializing player...');

      // ✅ Step 1: Initialize player (create if not exists)
      const initResponse = await fortuneCardApi.initPlayer();
      //console.log('✅ Player initialized:', initResponse);
    } catch (initError) {
      //console.error('⚠️ Init player error:', initError);
      // Continue anyway - player might already exist
    }
  };
  // ✅ Check user status (card + group)
  const checkUserStatus = async () => {
    try {
      setLoading(true);

      // Check if user has card
      const cardStatus = await fortuneCardApi.getCardStatus();
      setHasCard(cardStatus.data?.has_card || false);

      //console.log('[HOME] Card status:', cardStatus.data);

      // Check if user has owned group
      if (cardStatus.data?.has_card) {
        const groupResponse = await fortuneCardApi.getMyOwnedGroup();
        //console.log(groupResponse);
        if (groupResponse.data) {
          setMyGroup(groupResponse.data);
          //console.log('[HOME] User group:', groupResponse.data);
        }
      }

    } catch (error) {
      //console.error('[HOME] Check status error:', error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Handle start button click
  const handleStart = () => {
    onStart();
  };

  // ✅ Handle gang button click
  const handleMyGang = () => {
    navigate(`/game/fortune-card/my-group/`);
    /*if (myGroup) {
      navigate(`/game/fortune-card/share/${myGroup.group_code}`);
    } else {
      // No group → Start to create one
      onStart();
    }*/
  };

  // ✅ Handle coupons button click
  const handleMyCoupons = () => {
    navigate('/my-coupons');
  };

  // ✅ Determine button text
  const getStartButtonText = () => {

    //console.log(myGroup);
    if (!hasCard) {
      return 'เริ่มเลย';
    }
    if (myGroup) {
      return 'ตรวจสอบรายละเอียด';
    }
    return 'เริ่มเลย';
  };

  // ✅ Check if should show coupons button
  const showCouponsButton = myGroup && (
    myGroup.status === 'completed' ||
    myGroup.status === 'expired'
  );

  return (
    <div className="home-view">
      {/* Hero Section */}
      <section className="slip-hero" aria-hidden="true">
        <div className="slip-glow" />
        <img className="receipt-image" src={slip} alt="สลิปการซื้อ" />
        <div className="slip-orbit">
          {/* Optional: Add orbit items */}
        </div>
      </section>

      {/* Main Start Button */}
      <button
        className="cta home-cta"
        type="button"
        onClick={handleStart}
        disabled={loading}
      >
        <span className="coupons-icon ml-2">▶️</span>

        <span> {loading ? 'กำลังโหลด...' : getStartButtonText()}</span>
      </button>

      {/* My Gang Button - Always visible */}
      <button
        className="cta home-gang-btn"
        type="button"
        onClick={handleMyGang}
        disabled={loading}
      >
        <span className="gang-icon">👥</span>

        <span>กลุ่มของฉัน</span>
      </button>

      {/* My Coupons Button - Show only if completed/expired */}
      {showCouponsButton && (
        <button
          className="cta home-coupons-btn animate-fade-up"
          type="button"
          onClick={handleMyCoupons}
        >
          <span className="coupons-icon">🎁</span>
          <span>คูปองของฉัน</span>
        </button>
      )}

      {/* Group Status Info */}
      {/*{myGroup && !loading && (
        <div className="home-group-status animate-fade-up">
          <p className="status-text">
            {myGroup.status === 'completed' && '✅ กลุ่มครบแล้ว!'}
            {myGroup.status === 'active' && `👥 สมาชิก ${myGroup.members_count}/4 คน`}
            {myGroup.status === 'expired' && '⏰ กลุ่มหมดอายุ'}
          </p>
        </div>
      )}*/}

      {/* FAQ Button */}
      <button
        className="create-faq-fab"
        type="button"
        onClick={() => setShowTerms(true)}
        aria-label="FAQ"
      >
        ?
      </button>

      {showTerms && (
        <TermsPrivacy
          open={showTerms}
          onClose={() => setShowTerms(false)}
          onAccept={() => {
            setShowTerms(false);
            console.log("Accepted");
          }}
        />
      )}
    </div>
  );
};

export default HomeView;